<div class="mb-3">
    <label *ngIf="to.url" [attr.for]="key">
        <a
            class="btn-link"
            class="note-label"
            [href]="to.url"
            target="_blank"
            >{{ to.label }}</a
        >
    </label>
    <label *ngIf="!to.url" class="note-label" [attr.for]="key">{{
        to.label
    }}</label>
</div>
